import api from './api';

export type SearchResultType = 'course' | 'lesson' | 'wiki' | 'learning_path' | 'learning_group';

export interface SearchResult {
    type: SearchResultType;
    id: number;
    title: string;
    excerpt: string;
    url: string;
    relevance: number;
    difficulty?: string;
    thumbnail?: string;
    courseTitle?: string;
    courseId?: number;
}

export interface SearchFacets {
    types: {
        courses?: number;
        lessons?: number;
        wiki?: number;
        learning_paths?: number;
        learning_groups?: number;
    };
    difficulty: {
        beginner: number;
        intermediate: number;
        advanced: number;
    };
}

export interface SearchResponse {
    query: string;
    total: number;
    results: SearchResult[];
    facets: SearchFacets;
}

export interface SearchFilters {
    types?: SearchResultType[];
    difficulty?: 'beginner' | 'intermediate' | 'advanced';
    catalogId?: number;
    limit?: number;
    offset?: number;
}

class SearchService {
    /**
     * Search across all content types
     */
    async search(query: string, filters?: SearchFilters): Promise<SearchResponse> {
        const params = new URLSearchParams();
        params.append('q', query);

        if (filters?.types && filters.types.length > 0) {
            params.append('types', filters.types.join(','));
        }

        if (filters?.difficulty) {
            params.append('difficulty', filters.difficulty);
        }

        if (filters?.catalogId) {
            params.append('catalogId', filters.catalogId.toString());
        }

        if (filters?.limit) {
            params.append('limit', filters.limit.toString());
        }

        if (filters?.offset) {
            params.append('offset', filters.offset.toString());
        }

        const response = await api.get<SearchResponse>(`/search?${params.toString()}`);
        return response.data;
    }

    /**
     * Get search suggestions for autocomplete
     */
    async getSuggestions(query: string, limit: number = 5): Promise<string[]> {
        if (query.length < 2) {
            return [];
        }

        const params = new URLSearchParams();
        params.append('q', query);
        params.append('limit', limit.toString());

        const response = await api.get<string[]>(`/search/suggestions?${params.toString()}`);
        return response.data;
    }
}

export const searchService = new SearchService();
export default searchService;
